<template>
  <div>
    <router-view></router-view>
	<PageHeaderLayout>
    <div class="main-page-content">
      <div class="header">
        <div class="left_box">
          <span class="info">公司名称：</span>
          <el-input
            class="company_input"
            placeholder="请输入公司名称"
            v-model="searchCompanyName"
            clearable
          >
          </el-input>
          <el-button type="primary" @click="search">查询</el-button>
        </div>
        <el-button type="primary" class="add_btn" @click="handleAdd"
          >新增</el-button
        >
      </div>
      <ApeTable
        ref="apeTable"
        :data="dataList"
        :columns="columns"
        :loading="loadingStaus"
        :pagingData="pagingData"
        :current_Page="currentPage"
        @switchPaging="switchPaging"
        highlight-current-row
      >
        <el-table-column width="200" align="center" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button
                size="mini"
                class="edit_btn"
                @click="handleEdit(scope.row)"
                type="primary"
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleDelete(scope.row)"
                type="danger"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </ApeTable>
      <el-dialog
        title="添加"
        :visible.sync="dialogVisible"
        width="30%"
        center
        :before-close="handleClose"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="公司名称" prop="company_id">
            <el-select
              v-model="form.company_id"
              filterable
              placeholder="请选择公司"
              clearable
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button class="left_btn" @click="cancel">取 消</el-button>
          <el-button type="primary" @click="handleSure">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import { Message } from "element-ui";
export default {
  components: {
    ApeTable,
    PageHeaderLayout
  },
  data() {
    return {
      searchCompanyName: "",
      rowId: undefined,
      form: {
        company_id: "",
      },
      rules: {
        company_id: [
          { required: true, message: "请选择公司", trigger: "change" },
        ],
      },
      companyList: [],
      dialogVisible: false,
      dataList: [],
      columns: [
        {
          title: "公司id",
          value: "company_id",
          header_align: "center",
          align: "center",
        },
        {
          title: "公司名称",
          value: "companyName",
          header_align: "center",
          align: "center",
        },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
        },
      ],
      loadingStaus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      offset: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.init();
    this.getCompanyList();
  },
  methods: {
    async getCompanyList() {
      const res = await this.$api.getUserCompanyList();
      this.companyList = res;
    },
    switchPaging(e) {
      this.currentPage = e;
      this.init();
    },
    search() {
      this.init();
    },
    // 初始化公司列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (
        this.searchCompanyName === undefined ||
        this.searchCompanyName === ""
      ) {
        delete pagingInfo.company_name;
      } else {
        pagingInfo.company_name = this.searchCompanyName;
      }
      let { data, pages } = await this.$api.getCompanyRequiredList(pagingInfo);
      data.map((item) => {
        item.companyName = item.company.name;
      });
      this.$nextTick(() => {
        this.dataList = data;
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    handleClose() {
      this.rowId = undefined;
      this.dialogVisible = false;
    },
    cancel() {
      this.rowId = undefined;
      this.dialogVisible = false;
    },
    // 新增
    handleAdd() {
      this.form = {
        company_id: "",
      };
      this.dialogVisible = true;
      this.$refs["ruleForm"].resetFields()
    },
    // 编辑
    handleEdit(v) {
      this.rowId = v.id;
      this.form.company_id = v.company.id;
      this.dialogVisible = true;
    },
    // 删除
    handleDelete(v) {
      this.$confirm("此操作将永久删除该项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.deleteRequiredCard(v.id);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.init();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    handleSure() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if (this.rowId) {
            await this.$api.editRequiredCard(this.rowId, this.form);
          } else {
            await this.$api.postAddRequiredCard(this.form);
          }
          this.dialogVisible = false;
          this.rowId = undefined;
          Message.success("操作成功");
          this.init();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page-content {
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .left_box {
      .info {
        font-size: 14px;
        color: #606266;
      }
      .company_input {
        width: 200px;
        margin-right: 20px;
      }
    }
    .add_btn {
      margin-right: 50px;
    }
  }
  .demo-ruleForm {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-footer {
    .left_btn {
      margin-right: 20px;
    }
  }
  .edit_btn {
    margin-right: 2px;
  }
}
</style>
